/**
 * Created by mgoria on 12/22/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidProviderIdentityException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when provider identity metadata does not contain required fields (access_token and token expiration time)
 */
let InvalidProviderIdentityException = exports.InvalidProviderIdentityException = function (_Exception) {
  _inherits(InvalidProviderIdentityException, _Exception);

  /**
   * @param {String} providerName
   */
  function InvalidProviderIdentityException(providerName) {
    _classCallCheck(this, InvalidProviderIdentityException);

    return _possibleConstructorReturn(this, (InvalidProviderIdentityException.__proto__ || Object.getPrototypeOf(InvalidProviderIdentityException)).call(this, `Passed "${providerName}" identity does not contain mandatory access_token or tokenExpirationTime fields.`));
  }

  return InvalidProviderIdentityException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/Exception/InvalidProviderIdentityException.js
// module id = 438
// module chunks = 0